/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantKind } from './participant-kind';
import {
    ParticipantKindFromJSON,
    ParticipantKindFromJSONTyped,
    ParticipantKindToJSON,
    ParticipantKindToJSONTyped,
} from './participant-kind';

/**
 * 
 * @export
 * @interface ParticipantPostRequest
 */
export interface ParticipantPostRequest {
    /**
     * Unique identifier for a conversation participant.
     * @type {string}
     * @memberof ParticipantPostRequest
     */
    id: string;
    /**
     * The kind of the participant.
     * @type {ParticipantKind}
     * @memberof ParticipantPostRequest
     */
    kind: ParticipantKind;
    /**
     * The display name of the participant. If empty or null, the display name will be generated from the id.
     * @type {string}
     * @memberof ParticipantPostRequest
     */
    displayName?: string | null;
    /**
     * The phone number of a participant if he is a CLIENT. The field is otherwise always null.
     * @type {string}
     * @memberof ParticipantPostRequest
     */
    phoneNumber?: string | null;
    /**
     * The email of a participant if he is a CLIENT. The field is otherwise always null.
     * @type {string}
     * @memberof ParticipantPostRequest
     */
    email?: string | null;
    /**
     * The userId of a participant if he is a USER. The field is otherwise always null.
     * @type {string}
     * @memberof ParticipantPostRequest
     */
    userId?: string | null;
}



/**
 * Check if a given object implements the ParticipantPostRequest interface.
 */
export function instanceOfParticipantPostRequest(value: object): value is ParticipantPostRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function ParticipantPostRequestFromJSON(json: any): ParticipantPostRequest {
    return ParticipantPostRequestFromJSONTyped(json, false);
}

export function ParticipantPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kind': ParticipantKindFromJSON(json['kind']),
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'email': json['email'] == null ? undefined : json['email'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function ParticipantPostRequestToJSON(json: any): ParticipantPostRequest {
    return ParticipantPostRequestToJSONTyped(json, false);
}

export function ParticipantPostRequestToJSONTyped(value?: ParticipantPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': ParticipantKindToJSON(value['kind']),
        'display_name': value['displayName'],
        'phone_number': value['phoneNumber'],
        'email': value['email'],
        'user_id': value['userId'],
    };
}

